module.exports = __webpack_public_path__ + "housingStatic/img/jdrz.e2c8f97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav_png/jdrz.png
// module id = YW28
// module chunks = 2